// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!./card.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./img/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 0px;
  /*
  min-width: 1024px;
  min-height: 780px;
  */
}

.hs-grid {
}
.hs-grid-white {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  background-color: white;
  border-radius: 16px;
  background-clip: padding-box;
  box-shadow: inset 0 0 0 1px #e6edf3;
}
.hs-grid-grey {
  padding-bottom: 24px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(1, 1fr);
  gap: 10px;
  width: auto;
  height: auto;
  /*border: 1px solid black;*/
  /*background-color: blue;*/
}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  /*background-color: green;*/
  /*border: 1px solid purple;*/
}

.grid-header {
  display: flex;
  flex-grow: 0;
  height: 24px;
  /*background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);*/
  padding: var(--Spacings-Spacing-06, 1px);
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: auto !important;
  flex-wrap: wrap;
}

.grid-actions {
  display: flex;
  align-items: center;
  padding: 4px;
}

.gridstack-toolbar {
  align-self: flex-end;
  height: 25px;
  display: none;
  margin-right: 6px;
}

.grid-toolbar {
  align-self: flex-end;
  height: 25px;
  display: none;
}

.toolbar-action {
  gap: var(--Spacings-Spacing-03, 12px);
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  display: inline;
  padding-left: 6px;
}

.toolbar-action:hover {
  color: var(--med-grey);
}

.toolbar-action:active {
  color: var(--light-grey);
}

.toolbar-img {
  height: 18px;
  width: 18px;
  opacity: 0.7;
  padding-top: 3px;
}

.toolbar-img:hover {
  opacity: 1.0;
}

.toolbar-img:active {
  opacity: 0.3;
}

.grid-body {
  display: flex;
  flex-grow: 1;
}

.grid-title {
  font-size: 16px;
  font-weight: 700;
  color: rgb(0, 50, 82);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
}
.data-count {
  font-size: 28px;
  font-weight: 700;
  color: #113E57;
}


.grid-header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.grid-header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.toolbar-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
}

.toolbar-row-stats {
  display: none;
  flex: 0 0 100%;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 16px;
}

.grid-header.stats-left .toolbar-row-stats {
  display: flex;
}

.grid-header.stats-right .toolbar-row-stats {
  display: flex;
  justify-content: flex-end;
}

.report-picker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  white-space: nowrap;
}

.picker-label {
  font-weight: 500;
  font-size: 12px;
  color: #666;
  pointer-events: none;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}

.report-picker-select {
  appearance: none;
  -webkit-appearance: none;
  height: 48px;
  padding: 0 42px 0 20px;
  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4);
  border-radius: 16px;
  background-color: var(--Colors-UI-Neutral-Grey-0, #FFF);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: 'Euclid Circular A', sans-serif;
  cursor: pointer;
  white-space: nowrap;
  min-width: 200px;
  box-sizing: border-box;
}

.report-picker-select:hover {
  background-color: #F0F4F8;
}

.report-picker-select:active {
  background-color: #E0E8F0;
}

.report-picker-select:focus {
  outline: none;
  border-color: #4E758E;
}



.tabbar-container {
  display: flex;
  flex-direction: row;
  gap: 32px;
  align-items: center;
  padding: 0px;
  margin-bottom: 24px;
  height: 48px;
  justify-content: flex-start;
}
.tabbar-item {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 0;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
  color: var(--Colors-UI-Neutral-Grey-500, #808080);
}
.tabbar-item.clickable {
  cursor: pointer;
  user-select: none;
}
.tabbar-item.clickable:hover {
  /*font-weight: 700;*/
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}
.tabbar-item.clickable:active {
  /*font-weight: 700;*/
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}
.tabbar-item.selected {
  font-weight: 700;
  border-bottom: 4px solid var(--Colors-UI-Primary-Primary-Medium, #005D98);
  color: var(--Colors-UI-Primary-Primary-Dark, #003252);
}

#search {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 0;

  #search-text {
    position: relative;
    display: inline-block;
    background: white;
    color: #525252;
    font-size: 16px;
    font-weight: 400;
    border-radius: 16px;
    width: 240px !important;
    height: 46px !important;
    border: 1px solid #CCDCE4 !important;
    padding-left: 40px;
    box-sizing: border-box;
  }

  #search-text:focus {
    outline: none;
    /* Removes default outline */
    border: 1px solid rgb(204, 220, 228) !important;
    box-shadow: 0 0 5px rgba(204, 220, 228, 0.5);
  }
}

.search-wrapper {
  position: relative;
  display: inline-block;
}

#search-input {
  padding-left: 32px;
  /* space for the icon */
  height: 36px;
  position: relative;
  display: inline-block;
  background: white;
  color: rgb(82, 82, 82);
  font-size: 12px;
  font-weight: 400;
  width: 240px !important;
  height: 48px !important;
  border: 1px solid rgb(204, 220, 228) !important;
  border-radius: 12px;
}

.search-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/staticgrid.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX;;;GAGC;AACH;;AAEA;AACA;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kCAAkC;EAClC,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,+DAA+D;EAC/D,wCAAwC;EACxC,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;EACtB,qEAAqE;EACrE,mBAAmB;EACnB,uDAAuD;EACvD,yDAA6C;EAC7C,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,oEAAoE;EACpE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,qDAAqD;AACvD;AACA;EACE,gBAAgB;EAChB,yEAAyE;EACzE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;;EAEd;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,+CAA+C;IAC/C,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB","sourcesContent":["@import url(\"./global.css\");\n@import url(\"./card.css\");\n\n:host {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0px;\n  /*\n  min-width: 1024px;\n  min-height: 780px;\n  */\n}\n\n.hs-grid {\n}\n.hs-grid-white {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  padding-left: 24px;\n  padding-right: 24px;\n  background-color: white;\n  border-radius: 16px;\n  background-clip: padding-box;\n  box-shadow: inset 0 0 0 1px #e6edf3;\n}\n.hs-grid-grey {\n  padding-bottom: 24px;\n}\n\n.grid-container {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n  gap: 10px;\n  width: auto;\n  height: auto;\n  /*border: 1px solid black;*/\n  /*background-color: blue;*/\n}\n\n.grid-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /*background-color: green;*/\n  /*border: 1px solid purple;*/\n}\n\n.grid-header {\n  display: flex;\n  flex-grow: 0;\n  height: 24px;\n  /*background: var(--Colors-UI-Primary-Primary-Light, #D9ECFA);*/\n  padding: var(--Spacings-Spacing-06, 1px);\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  height: auto !important;\n  flex-wrap: wrap;\n}\n\n.grid-actions {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n\n.gridstack-toolbar {\n  align-self: flex-end;\n  height: 25px;\n  display: none;\n  margin-right: 6px;\n}\n\n.grid-toolbar {\n  align-self: flex-end;\n  height: 25px;\n  display: none;\n}\n\n.toolbar-action {\n  gap: var(--Spacings-Spacing-03, 12px);\n  cursor: pointer;\n  font-weight: 600;\n  user-select: none;\n  display: inline;\n  padding-left: 6px;\n}\n\n.toolbar-action:hover {\n  color: var(--med-grey);\n}\n\n.toolbar-action:active {\n  color: var(--light-grey);\n}\n\n.toolbar-img {\n  height: 18px;\n  width: 18px;\n  opacity: 0.7;\n  padding-top: 3px;\n}\n\n.toolbar-img:hover {\n  opacity: 1.0;\n}\n\n.toolbar-img:active {\n  opacity: 0.3;\n}\n\n.grid-body {\n  display: flex;\n  flex-grow: 1;\n}\n\n.grid-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: rgb(0, 50, 82);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px;\n}\n.data-count {\n  font-size: 28px;\n  font-weight: 700;\n  color: #113E57;\n}\n\n\n.grid-header-left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n.grid-header-right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.toolbar-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  justify-content: flex-end;\n}\n\n.toolbar-row-stats {\n  display: none;\n  flex: 0 0 100%;\n  justify-content: flex-start;\n  align-items: flex-end;\n  gap: 16px;\n}\n\n.grid-header.stats-left .toolbar-row-stats {\n  display: flex;\n}\n\n.grid-header.stats-right .toolbar-row-stats {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.report-picker-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.picker-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: #666;\n  pointer-events: none;\n  white-space: nowrap;\n  margin: 0;\n  padding: 0;\n}\n\n.report-picker-select {\n  appearance: none;\n  -webkit-appearance: none;\n  height: 48px;\n  padding: 0 42px 0 20px;\n  border: 1px solid var(--Colors-UI-Secondary-Secondary-Light, #CCDCE4);\n  border-radius: 16px;\n  background-color: var(--Colors-UI-Neutral-Grey-0, #FFF);\n  background-image: url('./img/arrow-down.svg');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  color: var(--Colors-UI-Status-Information-Information-Dark, #023650);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: 'Euclid Circular A', sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n  min-width: 200px;\n  box-sizing: border-box;\n}\n\n.report-picker-select:hover {\n  background-color: #F0F4F8;\n}\n\n.report-picker-select:active {\n  background-color: #E0E8F0;\n}\n\n.report-picker-select:focus {\n  outline: none;\n  border-color: #4E758E;\n}\n\n\n\n.tabbar-container {\n  display: flex;\n  flex-direction: row;\n  gap: 32px;\n  align-items: center;\n  padding: 0px;\n  margin-bottom: 24px;\n  height: 48px;\n  justify-content: flex-start;\n}\n.tabbar-item {\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding-top: 0;\n  padding-bottom: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n  color: var(--Colors-UI-Neutral-Grey-500, #808080);\n}\n.tabbar-item.clickable {\n  cursor: pointer;\n  user-select: none;\n}\n.tabbar-item.clickable:hover {\n  /*font-weight: 700;*/\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n.tabbar-item.clickable:active {\n  /*font-weight: 700;*/\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n.tabbar-item.selected {\n  font-weight: 700;\n  border-bottom: 4px solid var(--Colors-UI-Primary-Primary-Medium, #005D98);\n  color: var(--Colors-UI-Primary-Primary-Dark, #003252);\n}\n\n#search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: 0;\n\n  #search-text {\n    position: relative;\n    display: inline-block;\n    background: white;\n    color: #525252;\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 16px;\n    width: 240px !important;\n    height: 46px !important;\n    border: 1px solid #CCDCE4 !important;\n    padding-left: 40px;\n    box-sizing: border-box;\n  }\n\n  #search-text:focus {\n    outline: none;\n    /* Removes default outline */\n    border: 1px solid rgb(204, 220, 228) !important;\n    box-shadow: 0 0 5px rgba(204, 220, 228, 0.5);\n  }\n}\n\n.search-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n#search-input {\n  padding-left: 32px;\n  /* space for the icon */\n  height: 36px;\n  position: relative;\n  display: inline-block;\n  background: white;\n  color: rgb(82, 82, 82);\n  font-size: 12px;\n  font-weight: 400;\n  width: 240px !important;\n  height: 48px !important;\n  border: 1px solid rgb(204, 220, 228) !important;\n  border-radius: 12px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
